import script from "./MeetingRoomReservationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MeetingRoomReservationDialog.vue?vue&type=script&setup=true&lang=js"

import "./MeetingRoomReservationDialog.vue?vue&type=style&index=0&id=dc92a2e4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc92a2e4"]])

export default __exports__